import { useState } from 'react'
import Swal from 'sweetalert2'

export const useStatusFilter = updateFilters => {
	const [selectedStatus, setSelectedStatus] = useState('')

	const statusOptions = [
		{ value: 'new', label: 'New' },
		{ value: 'won', label: 'Won' },
		{ value: 'lost', label: 'Lost' },
	]

	const handleStatusFilter = () => {
		const radioButtonsHtml = statusOptions
			.map(
				status => `
            <div style="text-align: left; margin-bottom: 10px;">
                <label style="display: flex; align-items: center; cursor: pointer;">
                    <input type="radio" name="status" id="status-${status.value}" value="${status.value}" 
                           ${selectedStatus === status.value ? 'checked' : ''} 
                           style="margin-right: 8px;">
                    <span>${status.label}</span>
                </label>
            </div>
        `
			)
			.join('')

		Swal.fire({
			title: 'Select Status',
			html: `
                <div style="text-align: left;">
                    <div style="margin-bottom: 10px">Choose a status to filter by:</div>
                    ${radioButtonsHtml}
                </div>
            `,
			showCancelButton: true,
			showDenyButton: true,
			confirmButtonText: 'Apply Filter',
			denyButtonText: 'Clear Filters',
			cancelButtonText: 'Cancel',
			customClass: {
				denyButton: 'swal2-deny',
			},
			preConfirm: () => {
				const selectedRadio = document.querySelector('input[name="status"]:checked')
				return selectedRadio ? selectedRadio.value : ''
			},
		}).then(result => {
			if (result.isDenied) {
				setSelectedStatus('')
				updateFilters({ status: null })
			} else if (result.isConfirmed) {
				const newSelectedStatus = result.value || ''

				setSelectedStatus(newSelectedStatus)

				if (newSelectedStatus) {
					updateFilters({ status: newSelectedStatus })
				} else {
					updateFilters({ status: null })
				}
			}
		})
	}

	return {
		selectedStatus,
		handleStatusFilter,
	}
}
